import { useEffect, useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { DataContext } from 'providers/data';
import { ParamsPageWebView, ParamsDataGetListarCotacoes } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import Modals from 'components/views/Modals';
import ParseWebView from 'components/views/ParseWebView';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';
import { ReactComponent as IcDeleted } from 'assets/icons/ic-deleted.svg';

import { GridTab } from '../styles';

const ExchangesInProgress = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const [itemSelected, setItemSelected] = useState(0);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [isLoadingDeleted, setIsLoadingDeleted] = useState(false);
    const [showOptionDeleted, setShowOptionDeleted] = useState(false);
    const [showModalNotExist, setShowModalNotExist] = useState(false);
    const [showModalDeleted, setShowModalDeleted] = useState({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 });
    const [dataListarCotacoesState, setDataListarCotacoesState] = useState<Array<ParamsDataGetListarCotacoes>>();
    const { dataListarCotacoes, selectedCar, dataPostCancelChange, isPendingTicket, handleErrorTicketOpen, handleGetListarCotacoes, handlePostGetStatus, handlePostCancelChange } = useContext(DataContext);

    const handlePostCancelChangeState = () => {
        setIsLoadingDeleted(true);
        setItemSelected(showModalDeleted.cD_COTACAO);
        handlePostCancelChange({ cD_COTACAO: showModalDeleted.cD_COTACAO, cD_PESSOA: showModalDeleted.cD_PESSOA });
    }

    const handleSwitchTypeQuotation = (NR_TIPO_COTACAO: number) => {
        switch (NR_TIPO_COTACAO) {
            case 3:
                return 'Troca de serviço';
            case 4:
                return 'Troca de veículo';
            case 5:
                return 'Troca de Equipamento';
        }
    }

    const handlePostGetStatusState = async (cD_PEDIDO: number, cD_COTACAO: number, GUID_COTACAO: string) => {
        if (selectedCar) {
            setIsLoadingStatus(true);
            setItemSelected(cD_COTACAO);
            const status = await handlePostGetStatus({ body: { cD_PEDIDO: cD_PEDIDO, customerId: selectedCar?.CD_PESSOA, GUID_COTACAO: GUID_COTACAO }, isWebView });
            if(isPendingTicket && (status?.cotacaoPedidoStatus === 2 || status?.cotacaoPedidoStatus === 3)){
                handleErrorTicketOpen(true)
            }
        }
    }

    useEffect(() => {
        if (!dataListarCotacoes && selectedCar) {
            handleGetListarCotacoes(selectedCar.NR_CNPJ_CPF);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (dataListarCotacoes) {
            let dataListarCotacoesAux: Array<ParamsDataGetListarCotacoes> = [];
            let dataListarCotacoesAuxListWipe: Array<ParamsDataGetListarCotacoes> = [];

            dataListarCotacoes.map((value) => (dataListarCotacoesAux?.findIndex(({ NR_PLATAFORMA_ORIGEM }) => NR_PLATAFORMA_ORIGEM === value.NR_PLATAFORMA_ORIGEM) === -1) && dataListarCotacoesAux.push(value));

            // eslint-disable-next-line array-callback-return
            dataListarCotacoesAux.map(({ NR_PLATAFORMA_ORIGEM }) => {
                const filterAux = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 3) && (STATUS_PEDIDO_COTACAO < 5)));
                const filterAuxPlataform = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 4) && (STATUS_PEDIDO_COTACAO < 2)));

                if (filterAux?.length > 0) {
                    let max = filterAux.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }

                if (filterAuxPlataform?.length > 0) {
                    let max = filterAuxPlataform.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }
            });

            dataListarCotacoesAux.length > 0 && setDataListarCotacoesState(dataListarCotacoesAuxListWipe);
        } else if (dataListarCotacoes === false) {
            setDataListarCotacoesState(undefined);
            setShowModalNotExist(true);
        }
    }, [dataListarCotacoes]);

    useEffect(() => {
        if (dataListarCotacoes !== undefined) {
            setItemSelected(0);
            setIsLoadingStatus(false);
            setIsLoadingDeleted(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListarCotacoes]);

    useEffect(() => {
        if (dataPostCancelChange !== undefined) {
            if (selectedCar) {
                handleGetListarCotacoes(selectedCar.NR_CNPJ_CPF);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPostCancelChange]);

    return (
        <ParseWebView title='Trocas em andamento' link={isWebView ? '/wb/central-de-trocas' : '/central-de-trocas'} isWebView={isWebView} typePage='subpage'>
            <Box sx={{ marginBottom: '2.8125rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <IcIturanCheck />
                <Typography fontSize='1.125rem'>
                    <strong>Escolha</strong> a troca que deseja continuar:
                </Typography>
            </Box>

            <GridTab sx={{ borderBottom: '1px solid rgba(141, 155, 181, 0.35)', position: 'relative' }}>
                <p>Tipo</p>
                <p>Placa</p>
                <p />
                <Box sx={{ position: 'absolute', right: '0', bottom: '.69rem', 'button': { width: '5rem', borderRadius: '6.25rem', fontWeight: '600', height: '1.5625rem', fontSize: '.75rem' } }}>
                    <ButtonOutlined name={showOptionDeleted ? 'FINALIZAR' : 'EXCLUIR'} onClick={() => setShowOptionDeleted(!showOptionDeleted)} />
                </Box>
            </GridTab>
            {dataListarCotacoesState?.map(({ DS_PLACA, CD_COTACAO, NR_TIPO_COTACAO, CD_PESSOA_ORIGEM, GUID_COTACAO }, index) =>
                <Box sx={{ display: 'grid', gridTemplateColumns: showOptionDeleted ? 'auto 4rem' : '1fr' }}>
                    <GridTab
                        key={index}
                        sx={{
                            padding: '1.31rem 0 1.18rem',
                            borderBottom: '1px solid #8D9BB5',
                            opacity: (isLoadingDeleted || isLoadingStatus) ? '.5' : '1',
                            cursor: (isLoadingDeleted || isLoadingStatus) ? 'not-allowed' : 'pointer',
                            ":hover": {
                                backgroundColor: 'rgba(16, 167, 224, 0.1)'
                            }
                        }} onClick={() => (!isLoadingDeleted && !isLoadingStatus) && handlePostGetStatusState(0, CD_COTACAO, GUID_COTACAO)}>
                        <h6>{handleSwitchTypeQuotation(NR_TIPO_COTACAO)}</h6>
                        <h6 style={{ paddingLeft: showOptionDeleted ? '2rem' : '0' }}>
                            {DS_PLACA}
                        </h6>
                        <Box sx={{ height: '1.25rem', marginTop: '-2px' }}>
                            {(isLoadingStatus && (itemSelected === CD_COTACAO)) ?
                                <CircularProgress sx={{ maxWidth: '1.25rem', maxHeight: '1.25rem' }} />
                                :
                                <ArrowForwardIosIcon fontSize='small' />
                            }
                        </Box>
                    </GridTab>
                    {showOptionDeleted &&
                        <Box sx={{
                            borderLeft: '1px solid #8D9BB5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '.45rem 0',
                            opacity: (isLoadingDeleted || isLoadingStatus) ? '.5' : '1'
                        }}>
                            {(isLoadingDeleted && (itemSelected === CD_COTACAO)) ?
                                <CircularProgress sx={{ maxWidth: '1.75rem', maxHeight: '1.75rem' }} />
                                :
                                <IcDeleted
                                    onClick={() => (!isLoadingDeleted && !isLoadingStatus) && setShowModalDeleted({ show: true, cD_COTACAO: CD_COTACAO, cD_PESSOA: CD_PESSOA_ORIGEM })}
                                    style={{ cursor: (isLoadingDeleted || isLoadingStatus) ? 'not-allowed' : 'pointer' }} />
                            }
                        </Box>
                    }
                </Box>
            )}

            <Modals open={showModalDeleted.show}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Tem certeza que deseja excluir esta<br />
                            contratação em andamento?
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='EXCLUIR' onClick={() => { setShowModalDeleted({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 }); handlePostCancelChangeState() }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setShowModalDeleted({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 })} />
                        </Box>
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalNotExist}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Não existe trocas em andamento.
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='Voltar' onClick={() => { setShowModalNotExist(false); navigate(isWebView ? '/wb/central-de-trocas' : '/central-de-trocas') }} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </ParseWebView >
    );
}

export default ExchangesInProgress;